import {SVGProps} from 'react';

interface CreditCardIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CreditCardIcon = ({className, ...props}: CreditCardIconProps) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <rect width="20" height="14" x="2" y="5" rx="2" />
    <line x1="2" x2="22" y1="10" y2="10" />
  </svg>
);
